module.exports = __webpack_public_path__ + "static/media/house2.614b000c.jpeg";